import * as React from "react";
import { forwardRef } from "react";
const SvgReserve = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 26 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M2.84615 5.19238C2.35652 5.19238 1.88695 5.38689 1.54073 5.73311C1.1945 6.07933 1 6.54891 1 7.03854V23.6539C1 24.1436 1.1945 24.6131 1.54073 24.9594C1.88695 25.3056 2.35652 25.5001 2.84615 25.5001H23.1538C23.6435 25.5001 24.1131 25.3056 24.4593 24.9594C24.8055 24.6131 25 24.1436 25 23.6539V7.03854C25 6.54891 24.8055 6.07933 24.4593 5.73311C24.1131 5.38689 23.6435 5.19238 23.1538 5.19238H19.4615",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M6.53857 1.5V8.88461",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M19.4614 1.5V8.88461",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M6.53857 5.19238H15.7693",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M6.53856 15.3462C7.04836 15.3462 7.46163 14.9329 7.46163 14.4231C7.46163 13.9133 7.04836 13.5 6.53856 13.5C6.02875 13.5 5.61548 13.9133 5.61548 14.4231C5.61548 14.9329 6.02875 15.3462 6.53856 15.3462Z",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M13 15.3462C13.5098 15.3462 13.9231 14.9329 13.9231 14.4231C13.9231 13.9133 13.5098 13.5 13 13.5C12.4902 13.5 12.0769 13.9133 12.0769 14.4231C12.0769 14.9329 12.4902 15.3462 13 15.3462Z",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M19.4617 15.3462C19.9715 15.3462 20.3847 14.9329 20.3847 14.4231C20.3847 13.9133 19.9715 13.5 19.4617 13.5C18.9518 13.5 18.5386 13.9133 18.5386 14.4231C18.5386 14.9329 18.9518 15.3462 19.4617 15.3462Z",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M6.53856 20.8846C7.04836 20.8846 7.46163 20.4713 7.46163 19.9615C7.46163 19.4517 7.04836 19.0385 6.53856 19.0385C6.02875 19.0385 5.61548 19.4517 5.61548 19.9615C5.61548 20.4713 6.02875 20.8846 6.53856 20.8846Z",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgReserve);
export default ForwardRef;
